import produce from 'immer';
import {
  ACCOUNT_CURRENT_NICKNAME_UPDATE_REQUEST,
  ACCOUNT_CURRENT_POWER_UPDATE_REQUEST,
  ACCOUNT_DEFAULT_INFO_REQUEST, ACCOUNT_IMMEDIATE_WITHDRAWAL_REQUEST,
  ACCOUNT_INVENTORY_INFO_REQUEST,
  ACCOUNT_LIST_REQUEST,
  ACCOUNT_PUNISH_STATUS_UPDATE,
  ACCOUNT_RESPONSE_MESSAGE, ACCOUNT_WITHDRAWAL_CANCEL_REQUEST,
  SET_ACCOUNT_DEFAULT_INFO,
  SET_ACCOUNT_INVENTORY_INFO,
  SET_ACCOUNT_LIST,
  SET_ACCOUNT_PAGE
} from '../../constants/user/perplayUserConstants';

const initialState = {
  accountList: [],
  defaultInfo: [],
  inventoryInfo: null,
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  resultCode: null,
  message: '',
};

/* eslint-disable default-case, no-param-reassign */
const perplayUserReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case ACCOUNT_LIST_REQUEST:
    case ACCOUNT_DEFAULT_INFO_REQUEST:
    case ACCOUNT_INVENTORY_INFO_REQUEST:
      break;
    case SET_ACCOUNT_LIST:
      draft.accountList = action.list;
      break;
    case SET_ACCOUNT_PAGE:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.searchString = action.searchString;
      break;
    case SET_ACCOUNT_DEFAULT_INFO:
      draft.defaultInfo = action.info;
      break;
    case SET_ACCOUNT_INVENTORY_INFO:
      draft.inventoryInfo = action.info;
      break;
    case ACCOUNT_PUNISH_STATUS_UPDATE:
      draft.accountNo = action.accountNo;
      draft.reasonSort = action.reasonSort;
      draft.period = action.period;
      draft.reason = action.reason;
      break;
    case ACCOUNT_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    case ACCOUNT_CURRENT_POWER_UPDATE_REQUEST:
      break;
    case ACCOUNT_CURRENT_NICKNAME_UPDATE_REQUEST:
      break;
    case ACCOUNT_WITHDRAWAL_CANCEL_REQUEST:
      break;
    case ACCOUNT_IMMEDIATE_WITHDRAWAL_REQUEST:
      break;
    default:
      break;
  }
});

export default perplayUserReducer;
